import { createSlice } from '@reduxjs/toolkit';

import { IQuoteRequestForm } from '../../../Common/Api/Form/Types/Form/Form';
import { postQuoteRequestFormBuilder } from './postQuoteRequestForm';

export const initialState: IQuoteRequestForm = {
    detail: {
        validation_errors: {
            email: [],
            name: [],
            phone: [],
            message: [],
            // subject: [],
        }
    },
    request_states: {
        post: {
            pending: false, fulfilled: false, rejected: false,
            error_description: "",
        },
    },
    error_description: "",
}

export const QuoteRequestFormSlice = createSlice({
    name: 'quoteRequest_form',
    initialState,
    reducers: {
        update: (state, action) => {
            return {
                ...state,
                ...action.payload,
            }
        },
        reset: (state) => {
            return {
                ...state,
                ...initialState,
            }
        },
        updateValidationErrors: (state, action) => {
            return {
                ...state,
                detail: {
                    ...state.detail,
                    validation_errors: {
                        ...state.detail.validation_errors,
                        ...action.payload,
                    }
                }
            }
        },
        resetValidationErrors: (state) => {
            return {
                ...state,
                detail: {
                    ...state.detail,
                    validation_errors: {
                        email: [],
                        name: [],
                        phone: [],
                        message: [],
                        subject: [],
                    },
                }
            }
        },
        resetPostState: (state) => {
            return {
                ...state,
                request_states: {
                    ...state.request_states,
                    post: {
                        ...state.request_states.post,
                        pending: false,
                        fulfilled: false,
                        rejected: false,
                        error_description: "",
                    }
                },
            }
        },
    },
    extraReducers: builder => {
        postQuoteRequestFormBuilder(builder);
    }
});

export const { 
    update,resetPostState, updateValidationErrors,resetValidationErrors, reset
} = QuoteRequestFormSlice.actions;

export * from "./postQuoteRequestForm";

export default QuoteRequestFormSlice.reducer;